export const JOINT_SALE_PARTNER_MAP = Object.freeze({
  BD_BRICK_MORTAR: 'bd_brick_mortar'
});

/**
 * Check if the current URL is from a joint sale partner
 * @param {String} partnerName - The name of the partner
 * @returns {Boolean}
 */
export const isUrlJointSalePartner = (partnerName) => {
  const jointSale = new URLSearchParams(window.location.search).get('jointsale');
  return jointSale === partnerName;
}

/**
 * Check if the current URL is from the Brick Mortar joint sale partner
 * @returns {Boolean}
 */
export const isBrickMortarJointSalePartner = () => {
  return isUrlJointSalePartner(JOINT_SALE_PARTNER_MAP.BD_BRICK_MORTAR);
}